<form [formGroup]="voorlAanslag">
      <snelstart-ui-number-form-control
        formControlName="voorlopigeAanslag"
        label="Voorlopige aanslag(en) IB {{ this.incomeTaxEntity.aangifte?.aangifteJaar}}"
        id="voorlopigeAanslag"
        class="custom-input-250"
        [decimals]="0"
        align="right"
        prefix="€"
        [disabledControl]="voorlTeruggaaf.value.voorlopigeAanslag !== null"
        (change)="saveForm()"
      >
      </snelstart-ui-number-form-control>
</form>
<form [formGroup]="voorlTeruggaaf">
      <snelstart-ui-number-form-control
        formControlName="voorlopigeAanslag"
        label="Voorlopige teruggave(n) IB {{ this.incomeTaxEntity.aangifte?.aangifteJaar}}"
        id="voorlopigeAanslagTeruggaaf"
        class="custom-input-250"
        [decimals]="0"
        [disabledControl]="voorlAanslag.value.voorlopigeAanslag !== null"
        align="right"
        prefix="€"
        (change)="saveForm()"
      >
      </snelstart-ui-number-form-control>
</form>
<form [formGroup]="voorlZvw">
      <snelstart-ui-number-form-control
        formControlName="voorlopigeAanslagZvw"
        label="Voorlopige aanslag(en) ZVW {{ this.incomeTaxEntity.aangifte?.aangifteJaar}}"
        id="voorlopigeAanslagZvw"
        class="custom-input-250"
        [decimals]="0"
        align="right"
        prefix="€"
        (change)="saveForm()"
      >
      </snelstart-ui-number-form-control>
</form>

